// extracted by mini-css-extract-plugin
export default {"subtext":"event-pricing_subtext__7Ab2q"};